import type { AnalyticsEventData } from '../../../../core/analytics/analyticsTypes';

/**
 * Fire-and-forget VQE analytics from non-React code (commit pipeline, Edit as
 * SQL, the open funnel). Props are fixed, low-cardinality values — never SQL,
 * table or column names. An analytics failure never affects the action.
 */
export function trackVqeEvent(name: string, data: AnalyticsEventData): void {
  if (typeof window === 'undefined') return;
  window.electronAPI?.analytics?.track?.(name, data)?.catch?.(() => {});
}
